import { AxiosRequestConfig } from "axios";
import api from "./api-config";

export const fetcher =
  <T>(config?: AxiosRequestConfig) =>
  <T>(url: string) =>
    api.get<T>(url, config).then((response) => response.data);
